import React, { useState, useContext } from 'react';
import WindowSizeContext from '../helpers/window-size-context'
import getScreenSize from '../helpers/get-screen-size'
import ScrollPositionContext from '../helpers/scroll-position-context'
import Social from './social'
import Button from 'react-bootstrap/Button';
import HamburgerMenu from 'react-hamburger-menu';
import Container from '../components/container';
import SignUpDialog from '../components/signup-dialog.js'
import { requestDemoEmail } from '../helpers/emails'
import { GetContent } from '../helpers/content.js'
import { useQuery } from '../helpers/query-params.js'

function Header(info) {

  const CONTENT = GetContent();
  const [isOpen, setOpen] = useState(false);

  const showDialogOnStartup = useQuery('signup_dialog') === 'true';
  const [hasSignupDialog, setSignupDialog] = useState(showDialogOnStartup);
  const windowSize = useContext(WindowSizeContext)
  const scrollY = useContext(ScrollPositionContext)
  const { isDesktop, isTablet, isMobile } = getScreenSize(windowSize)
  const isScrolled = scrollY > 0;
  const styles = getStyles({ isDesktop, isTablet, isMobile, isScrolled })

  let links = (
    <>
      <Button id="header-cta" onClick={ () => (setSignupDialog(true)) } variant="dark" style={styles.cta}>{ CONTENT["header"]["cta"] }</Button>
    </>
  )

  let navigation = isMobile
    ? (
      <div style={styles.sectionRight}>
        <HamburgerMenu
          id="hamburger-menu"
          width={30}
          height={30}
          isOpen={isOpen}
          menuClicked={() => setOpen(!isOpen)}
        />
      </div>
    ) : (
      <div style={styles.sectionRight}>
        { links }
      </div>
    )

  let verticalMenu = (
    <div style={styles.verticalMenu}>
      { links }
    </div>
  )

  let logo = CONTENT['logo'] !== 'none'
    ? (<img style={styles.logoImage} src={CONTENT['logo']} />)
    : (<div style={styles.logoImage}>level</div>)

  logo = (
    <div style={styles.letterLogo} className="colored-background">
      <div id="logo-text" style={styles.logoText}>
        <a href="/">
          level
        </a>
      </div>
    </div>
  )


  return (
    <Container isHeader={true}>
      <div style={styles.headerContainer}>
        <div style={styles.logo}>{ logo }</div>
      </div>
    </Container>
  )
}

function getStyles({ isDesktop, isTablet, isMobile, isScrolled }) {
  let headerContainer;
  if (isDesktop) {
  }

  if (isTablet) {
  }

  if (isMobile) {
  }

  if (isScrolled) {
  }

  let styles = {
    logo: {
      fontSize: '44px',
      fontWeight: '400',
    },
    letterLogo: {
      lineHeight: '48px',
      color: 'white',
      textAlign: 'center',
      height: '50px',
      borderRadius: '50px',
      padding: '0px 20px 5px 20px',
      fontSize: '35px',
    },
    logoImage: {
      height: '75px',
      maxWidth: '100px',
    },
    headerContainer: {
      height: '110px',
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // Hack for 100% wide heading
    },
    link: {
      fontSize: '16px',
      fontWeight: '600',
      marginRight: '20px',
      color: '#000000',
      margin: "20px 20px 20px 0px"
    },
    sectionRight: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    header: {
      fontWeight: "700",
      fontSize: "44px",
    },
    subHeader: {
      fontSize: "25px",
    },
    verticalMenu: {
      display: 'flex',
      position: 'fixed',
      zIndex: 4,
      top: "105px",
      left: "0px",
      flexDirection: "column",
      justifyContent: "space-around",
      backgroundColor: "white",
      width: "100vw",
      padding: "50px 50px 50px 50px",
    },
  }
  return styles;
}

export default Header;
